export interface TeamMember {
  name: string;
  role: string;
  bio: string;
  linkedin: string | null;
  twitter: string | null;
  image: string | null;
  cardColor: string;
}

export interface TeamGroup {
  dept: string;
  members: TeamMember[];
}

export const TEAM: TeamGroup[] = [
  {
    dept: "Engineering",
    members: [
      {
        name: "Zac Baker",
        role: "Co-founder & CEO",
        bio: "Zac co-founded Terac to make rigorous customer research as fast as a search query. He leads the company and obsesses over panel quality, voice moderation, and the next surface we open up to AI agents.",
        linkedin: "https://www.linkedin.com/in/zacharyrbaker/",
        twitter: null,
        image: "/marketing/teams/zac-baker.png",
        cardColor: "#dfe6fd",
      },
      {
        name: "Jack Blair",
        role: "Co-founder & CTO",
        bio: "Jack co-founded Terac and leads engineering. He sets the technical direction across the platform, from the panel and moderator to the agent tooling that exposes Terac to other AIs.",
        linkedin: "https://www.linkedin.com/in/jackblair876/",
        twitter: null,
        image: "/marketing/teams/jack-blair.png",
        cardColor: "#e8fad2",
      },
      {
        name: "Prajwal Sharma",
        role: "Founding Engineer",
        bio: "Prajwal owns large parts of the Terac platform: researcher dashboards, the moderator pipeline, and the agent tooling that connects customers to verified experts. He thinks in shipped diffs.",
        linkedin: "https://www.linkedin.com/in/prajwalsharma03",
        twitter: null,
        image: "/marketing/teams/prajwal-sharma.png",
        cardColor: "#f7edf1",
      },
      {
        name: "Giovanni Borgogno",
        role: "Founding Engineer",
        bio: "Giovanni builds the systems behind Terac's voice interviews and submission workflows. He cares deeply about reliability and the small details that make a product feel calm to use.",
        linkedin: "https://www.linkedin.com/in/giovaborgogno/",
        twitter: null,
        image: "/marketing/teams/giovanni-borgogno.png",
        cardColor: "#ffe3dd",
      },
      {
        name: "Nicolas Russo",
        role: "Founding Engineer",
        bio: "Nicolas builds the trust and quality systems on the engineering side: identity, attestations, and the verification flows that make our experts truly verified, not just signed up.",
        linkedin: null,
        twitter: null,
        image: "/marketing/teams/nicolas-russo.png",
        cardColor: "#dfe6fd",
      },
      {
        name: "German Fernandez",
        role: "Founding Engineer",
        bio: "German builds the ads systems behind Terac's recruitment, from creative generation to spend routing across channels, so the right experts see the right study at the right time.",
        linkedin: null,
        twitter: null,
        image: "/marketing/teams/german-fernandez.png",
        cardColor: "#dfe6fd",
      },
      {
        name: "Nino Berishvili",
        role: "Support Engineer",
        bio: "Nino keeps Terac running smoothly for experts and researchers alike, triaging issues, fixing the rough edges, and making sure no submission, payout, or study gets stuck.",
        linkedin: null,
        twitter: null,
        image: "/marketing/teams/nino-berishvili.png",
        cardColor: "#ffe3dd",
      },
    ],
  },
  {
    dept: "Operations",
    members: [
      {
        name: "Moritz Kamke",
        role: "Operations",
        bio: "Moritz runs Terac's operations, keeping our panel healthy, our studies launching on time, and the day-to-day mechanics of the company calmly humming in the background.",
        linkedin: null,
        twitter: null,
        image: "/marketing/teams/moritz-kamke.png",
        cardColor: "#dfe6fd",
      },
      {
        name: "Claire Cavallini",
        role: "Head of Talent Operations",
        bio: "Claire leads talent operations at Terac, building the systems that find, vet, and grow the people behind every study, both on the panel side and inside the company.",
        linkedin: null,
        twitter: null,
        image: "/marketing/teams/claire-cavallini.png",
        cardColor: "#e8fad2",
      },
    ],
  },
];

/**
 * Headcount stated in copy. Ahead of `TEAM` until every new starter has a
 * card; the team section fills the gap with a single "and N more" card.
 */
export const TEAM_SIZE = 16;
